import { useEffect, useState } from "react";

function useFetch<T>(url: string, pollInterval?: number): { data: T | null, error: string | null } {
    const [data, setData] = useState<T | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let intervalId: ReturnType<typeof setInterval> | null = null;

        const fetchData = () => {
            fetch(url)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`Failed to fetch: ${response.status} ${response.statusText}`);
                    }
                    return response.json();
                })
                .then(setData)
                .catch((error) => setError(error.message));
        };

        fetchData();

        if (pollInterval) {
            intervalId = setInterval(fetchData, pollInterval);
        }

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [url, pollInterval]);

    return { data, error };
}

export default useFetch;